<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12 col-md-6">
          <h1 class="text-white pt-3 px-3">จัดการขนส่งภายในประเทศ</h1>
          <p
            class="text-white pb-3 px-3"
          >เพิ่ม แก้ไข ลบขนส่ง และแสดงตารางรายละเอียดขนส่งทั้งหมดที่มีอยู่</p>
        </div>
        <div class="col-12 col-md-6 text-right">
          <router-link
            to="/transport"
            class="btn btn-outline-light btn-icon btn-icon-add py-3"
            role="button"
          >
            <i class="fas fa-plus"></i>
            <p>เพิ่มขนส่ง</p>
          </router-link>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col d-flex align-items-center">
                  <h3 class="text-muted mb-0">ตารางแสดงข้อมูลขนส่ง</h3>
                </div>
                <div class="col-12 col-md-4">
                  <b-input-group>
                    <b-form-input v-model="tableCouriers.filter" placeholder="ค้นหาขนส่ง"></b-form-input>
                  </b-input-group>
                </div>
              </div>
            </div>
            <div>
              <!-- table-responsive scroll-bar-pop -->
              <div class="" >
                <b-table
                  responsive
                  show-empty
                  :items="tableCouriers.couriersList"
                  :fields="tableCouriers.fields"
                  :filter="tableCouriers.filter"
                  :busy="loader.busy"
                  class="scroll-bar-pop text-center table-sticky"
                >
                  <div slot="table-busy" class="text-center">
                    <BlockUI >
                    <div class="loader"></div>
                    </BlockUI>
                  </div>
                  <template slot="index" slot-scope="row">
                    {{ row.index+1 }}
                  </template>
                  <template slot="is_shippop" slot-scope="row">
                    <label v-if=" row.item.is_shippop == 1 || row.item.shippop == 1">{{$THEME.webTitle}}</label>
                    <label v-if=" row.item.key == 'GEN' && (row.item.is_shippop == 0 || row.item.shippop == 0)">GEN</label>
                    <label v-if=" row.item.key == 'SPGEN' && (row.item.is_shippop == 0 || row.item.shippop == 0)">SPGEN</label>
                  </template>
                  <template slot="actions" slot-scope="row">
                    <div>
                        <router-link :to="`/ratemanagement/${row.item.id}`" v-if="$USER_LOGIN.get().isShippop || $USER_LOGIN.get().isSuperadmin">
                            <button class="btn btn-sm px-3 btn-success mr-2" v-if="auth0RoleUsage('ratemanagement')">
                            นำไปใช้
                            </button>
                        </router-link>
                        <router-link :to="`/transport/${row.item.id}`">
                            <button class="btn btn-sm px-3 btn-info mr-2">
                            แก้ไข
                            </button>
                        </router-link>
                        <button 
                            class="btn btn-sm px-3 btn-danger"
                            @click="modalConfirmDeleteCourier( row.item.id )"  
                            v-if="auth0RoleUsage('transportdelete')">
                            ลบ
                        </button>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalNotification :notiShop="noti" />
  </div>
</template>

<script>
import validatePop from "../plugins/validatePop.js"
import ModalNotification from '@/components/custom/ModalNotification'
import { checkStatusShop } from "@/axios/noti.js";
import { auth0RoleUsage } from "@/helpers/auth0"
const API_URL = process.env.VUE_APP_API;
export default {
  components:{
    ModalNotification
  },
  data() {
    return {
      loader:{
        busy: false
      },
      permission:{
          userLogin:"",
      },
      tableCouriers:{
        filter:"",
        fields: [
          { key: 'index', label: 'ลำดับ', sortable: true },
          { key: 'code', label: 'รหัสเรทราคา', sortable: true },
          { key: 'name', label: 'ชื่อขนส่ง', sortable: true },
          { key: 'description', label: 'รายละเอียดขนส่ง' },
          { key: 'is_shippop', label: 'ประเภทขนส่ง', sortable: true },
          { key: 'actions', label: 'การจัดการ' , sortable: true},
        ],
        couriersList: []
      },
      noti:{
        show:false,
        type:"",
        created_by:"",
        router:false
      },
      auth0RoleUsage: auth0RoleUsage
    }
  },
  beforeMount(){
      this.permission.userLogin = JSON.parse(localStorage.getItem("user"));
  },
  mounted() {
    if(this.$USER_LOGIN.get().isSuperadmin){
        checkStatusShop().then(res => {
            if( res.status_shop == 'LOCK' ){
                this.noti.created_by = res.created_by
                this.noti.type = res.status_shop
                this.noti.show = true
            }
        })
    }
    if(localStorage.getItem("fakeUser")) {
      localStorage.removeItem("fakeUser")
      window.location.reload()
    }
    this.getDefaultCourier()
  },
  methods: {
    handleLoader(){
      this.loader.busy = !this.loader.busy
    },
    getDefaultCourier() {
      this.handleLoader()
      this.$http
        .get(API_URL + "/shop/superadmin/couriers", {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          this.tableCouriers.couriersList = res.data.data
          this.handleLoader()
        })
        .catch(error => {});
    },
    deleteCourier( idCourier ) {
      this.handleLoader()
      this.$http
        .delete(API_URL + `/shop/superadmin/courier/${idCourier}`, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.modalError( checkError.msg )
              return false
            }
            this.handleLoader()
            this.modalSuccess("ลบข้อมูลสำเร็จ")
            this.getDefaultCourier()
        })
    },
    adminDeleteCourier( idCourier ) {
      this.handleLoader()
      this.$http
        .delete(API_URL + `/courier/${idCourier}`, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.modalError( checkError.msg )
              return false
            }
            this.handleLoader()
            this.modalSuccess("ลบข้อมูลสำเร็จ")
            this.getDefaultCourier()
        });
    },
    isWho() {
      return this.permission.userLogin.role;
    },
    modalConfirmDeleteCourier( idCourier ) {
      this.$bvModal
        .msgBoxConfirm(`คุณต้องการจะลบขนส่ง `, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          //for P' OOOO
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value && (this.isWho() == 'superadmin' || this.isWho() == 'shippop') ){
            this.deleteCourier( idCourier );
          }else if( value ){
            this.adminDeleteCourier( idCourier )
          }else{

          }

        })
    },
    modalSuccess(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      })
    },
    modalError(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      })
    },
  }
};
</script>